import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import _ from 'lodash'

import callAPI from '../../../../../helpers/callAPI'
import Loading from '../../../../../templates/UI/Loading/Loading'
import AffiliateSearch from '../../../../../components/AffiliateSearch/AffiliateSearch'
import AdvertiserSearch from '../../../../../components/AdvertiserSearch/AdvertiserSearch'
import { Modal } from 'react-bootstrap'
import AdminPicker from '../../../../../components/AdminPicker/AdminPicker'
import CustomButton from '../../../../../templates/UI/CustomButton/CustomButton'
import { SystemMessageContext } from '../../../../../context/SystemMessageContext'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import CopyToClipboard from 'react-copy-to-clipboard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NotesLog from '../../../../../components/NotesLog/NotesLog'
import CampaignSearch from '../../../../../components/CampaignSearch/CampaignSearch'
import TextareaImage from '../../../../../components/TextareaImage/TextareaImage'

const maxLogLength = 500

const EditIssue = ({ type, handleClose, issueId, manager, advertiser, affiliate }) => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [issueInfo, setIssueInfo] = useState({ advertiser: advertiser, affiliate: affiliate })
    const [actionType, setActionType] = useState('create')
    const [adminId, setAdminId] = useState(0)
    const [submitting, setSubmitting] = useState(false)
    const { showSystemMessage } = useContext(SystemMessageContext)
    const [copied, setCopied] = useState('')

    const [logLength, setLogLength] = useState(0)
    const [file, setFile] = useState(false)
    const [preview, setPreview] = useState(false)
    const [logText, setLogText] = useState('')
    const [metWith, setMetWith] = useState('')
    const [postAsFollowup, setPostAsFollowup] = useState(false)

    const [confirmClose, setConfirmClose] = useState(false)

    let postAsFollowupOption = false
    let metWithDefault = true
    let createIssue = false

    if (issueId === 0) {
        createIssue = true
    }

    useEffect(() => {        
        if (createIssue) {
            setDataLoaded(true)
            return
        }
        getIssueInfo()
    }, [issueId])

    const getIssueInfo = () => {
        let url = `issue/${issueId}`

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    setIssueInfo(result.issue_info)
                } else {
                    showSystemMessage('error', result.errors.message)
                }
                setDataLoaded(true)
            })
            .catch((error) => {
                showSystemMessage('error', `An error occurred while fetching issue info: ${error.message}`)
            })
    }

    const submitForm = (e) => {
        e.preventDefault()
        setSubmitting(true)

        let postBody = {
            assignedTo: adminId > 0 ? adminId : issueInfo.assigned_to ? issueInfo.assigned_to : 0,
            campaignId: issueInfo.campaign ? issueInfo.campaign.id : 0,
            advertiserId: issueInfo.advertiser ? issueInfo.advertiser.id : 0,
            affiliateId: issueInfo.affiliate ? issueInfo.affiliate.id : 0,
            title: e.target.title.value,
            description: e.target.description.value,
            priority: issueInfo.priority,
            actionType: actionType
        }

        const formData = new FormData()

        let tempLogText = logText

        //add met with to logText if it exists
        if (metWithDefault) {
            tempLogText = `Met With: ${metWith}\n${tempLogText}`
        }

        formData.append('file', file)
        formData.append('log', tempLogText)
        formData.append('issueInfo', JSON.stringify(postBody))

        let url = `issue/${issueId}`

        callAPI(url, 'POST', formData, true)
            .then((result) => {
                if (result['success'] === true) {
                    showSystemMessage('success', result.message)
                    setSubmitting(false)
                    if (type === 'page') {
                        getIssueInfo()
                    }
                    handleClose(true)
                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                    setSubmitting(false)
                }
            })
            .catch((error) => {
                console.log(`Error while editing issue: ${error}`)
                showSystemMessage('error', 'Connection Error')
                setSubmitting(false)
            })
    }

    const inputChangeHandler = (e) => {
        // console.log(e.target.name, e.target.value);
    }

    let buttons

    if (issueId === 0) {
        buttons = (
            <CustomButton
                type="submit"
                name="Create Issue"
                onClick={() => {
                    setActionType('create')
                }}
                spin={submitting}
            />
        )
    } else if (issueInfo.status === 'O') {
        buttons = (
            <>
                <CustomButton
                    type="submit"
                    name="Save Changes"
                    onClick={() => {
                        setActionType('save')
                    }}
                    spin={submitting}
                />
                <span className="ml-3">
                    {
                        confirmClose ?
                            <CustomButton
                                type="submit"
                                variant="danger"
                                name="Confirm Save and Close"
                                onClick={() => {
                                    setActionType('close')
                                }}
                                spin={submitting}
                            />
                            :
                            <button
                                type="submit"
                                className="btn btn-outline-danger"
                                name="Save and Close Issue"
                                onClick={() => {
                                    setConfirmClose(true)
                                }}
                            >Save and Close Issue</button>
                    }

                </span>
            </>
        )
    }

    return (
        <React.Fragment>
            {type !== 'page' && <Modal.Header closeButton>
                <Modal.Title>{createIssue ? 'Create Issue' : 'Edit Issue'}</Modal.Title>
            </Modal.Header>}

            <div className={`${type === 'page' ? 'row' : ''}`}>
                <div className={`${type === 'page' ? 'col-md-8' : ''}`}>
                    <div className="card">
                        {(type !== 'page' && !createIssue) && <div className='alert alert-secondary m-3'>
                            Page Link : <Link to={`/issue/${issueId}`}>{`${process.env.REACT_APP_PORTAL_URL}/issue/${issueId}`}</Link>
                            <span className='ml-3'>
                                <CopyToClipboard text={`${process.env.REACT_APP_PORTAL_URL}/issue/${issueId}`} onCopy={() => setCopied(true)}>
                                    <button type="button" className="btn btn-outline-primary shadow-none" size="sm">
                                        <FontAwesomeIcon icon="copy" />
                                    </button>
                                </CopyToClipboard>
                            </span>
                        </div>}
                        <form onSubmit={submitForm} method="POST" className="form-group">
                            <div className="card-body p-3">
                                {dataLoaded ? (
                                    <div className="row">
                                        {!createIssue ?
                                            <div className="col-md-6">
                                                <NotesLog isIssue={true} uri="issue" id={issueId} refresh={getIssueInfo} fixedHeight={true} extraNotes={issueInfo.notes} metWithDefault={true} postAsFollowupOption={issueInfo.advertiser.id > 0 ? issueInfo.advertiser.id : (issueInfo.campaign && issueInfo.campaign.advertiser_id > 0 ? issueInfo.campaign.advertiser_id : false)} advertiserId={issueInfo.advertiser.id > 0 ? issueInfo.advertiser.id : (issueInfo.campaign && issueInfo.campaign.advertiser_id > 0 ? issueInfo.campaign.advertiser_id : false)} />
                                            </div>
                                            :
                                            <div className="col-md-6">
                                                <div className='card mb-3'>
                                                    <div className="card-header">
                                                        <h1 className="mb-h1-dark">Log</h1>
                                                    </div>
                                                    <div className='card-body p-0'>
                                                        <div style={{
                                                            backgroundColor: 'rgba(0,0,0,.03)',
                                                            height: '200px',
                                                            maxHeight: '200px',
                                                            flexDirection: 'column',
                                                            overflowY: 'auto'
                                                        }} className="p-2 border-bottom text-secondary"></div>
                                                        <div className="p-2">
                                                            <TextareaImage
                                                                metWith={metWith}
                                                                metWithDefault={metWithDefault}
                                                                setMetWith={setMetWith}
                                                                name="log"
                                                                required={true}
                                                                maxLength={maxLogLength}
                                                                preview={preview}
                                                                setPreview={setPreview}
                                                                setFile={setFile}
                                                                setLength={setLogLength}
                                                                postAsFollowupOption={postAsFollowupOption}
                                                                value={logText}
                                                                onChange={(e) => setLogText(e.target.value)}
                                                                onPostAsFollowupChange={(e) => setPostAsFollowup(e.target.checked)}
                                                            />

                                                            {/* <textarea 
                                                                name="initialNotes" 
                                                                maxLength={500} 
                                                                rows={4} 
                                                                cols={40} 
                                                                className="form-control" 
                                                                placeholder="Notes" 
                                                            />
                                                            <span className="text-secondary">*Attachments can only be added after the issue is created.</span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className="col-md-6">
                                            <table className="table table-card table-borderless w-100 m-0">
                                                <tbody>
                                                    {!createIssue && (
                                                        <>
                                                            <tr>
                                                                <td width="20%">Issue ID:</td>
                                                                <td width="80%">{issueInfo.issue_id}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Opened By:</td>
                                                                <td>
                                                                    {issueInfo.full_name} on {moment(issueInfo).format('YYYY-MM-DD')}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Status:</td>
                                                                <td>{issueInfo.status === 'O' ? `Open - Last Update on ${moment(issueInfo.last_update_date).format('YYYY-MM-DD')}` : `Closed on ${moment(issueInfo.closed_date).format('YYYY-MM-DD')}`}</td>
                                                            </tr>
                                                        </>
                                                    )}
                                                    <tr>
                                                        <td width="20%">&nbsp;</td>
                                                        <td width="80%">&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Title:</td>
                                                        <td>
                                                            <input name="title" defaultValue={_.unescape(issueInfo.title)} className="form-control form-control-sm" onChange={inputChangeHandler} required />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Description:</td>
                                                        <td>
                                                            <textarea name="description" maxLength={maxLogLength} defaultValue={_.unescape(issueInfo.description)} className="form-control" rows={6} onChange={inputChangeHandler} required />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Assign To:</td>
                                                        <td>
                                                            {/* <ManagerDropdown mgrId={issueInfo.assigned_to} mgrSelected={handleManagerChange} /> */}
                                                            <AdminPicker adminId={adminId > 0 ? adminId : issueInfo.assigned_to} setAdminId={setAdminId} required={true} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Priority:</td>
                                                        <td>
                                                            <select className="form-control form-control-sm w-50" defaultValue={issueInfo.priority} onChange={(e) => setIssueInfo({ ...issueInfo, priority: e.target.value })} required>
                                                                <option value=""></option>
                                                                <option value={1}>High</option>
                                                                <option value={2}>Medium</option>
                                                                <option value={3}>Low</option>
                                                                <option value={4}>Campaign Request</option>
                                                                <option value={5}>Ad Ops</option>
                                                                <option value={6}>Cap</option>
                                                                <option value={7}>Placement</option>
                                                                <option value={8}>Rate Increase</option>
                                                            <option value={9}>Compliance</option>
                                                            <option value={10}>Avatar</option>
                                                            </select>
                                                        </td>
                                                    </tr>
                                                    <tr className="align-items-center">
                                                        <td>Advertiser:</td>
                                                        <td>
                                                            <AdvertiserSearch advertiser={issueInfo.advertiser ? (issueInfo.advertiser.id ? { id: issueInfo.advertiser.id, name: issueInfo.advertiser.name } : false) : false} setFormData={setIssueInfo} order={3} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Campaign:</td>
                                                        <td>
                                                            <CampaignSearch campaign={issueInfo.campaign ? (issueInfo.campaign.id ? { id: issueInfo.campaign.id, name: issueInfo.campaign.name } : false) : false} setCampaign={console.log} setFormData={setIssueInfo} order={2} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Affiliate:</td>
                                                        <td>
                                                            <AffiliateSearch affiliate={issueInfo.affiliate ? (issueInfo.affiliate.id ? { id: issueInfo.affiliate.id, name: issueInfo.affiliate.name } : false) : false} setFormData={setIssueInfo} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                    </tr>


                                                    <tr>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className="text-right">
                                                {buttons}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <Loading />
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditIssue
